module.exports = __webpack_public_path__ + "static/media/Alessandria.a2799a47.png";